import { useCallback, useEffect } from 'react'
import { History } from 'history'
import { SponsoredListingProvider } from '@/features/SponsoredListing/modals/sponsor-wizard'
import SponsorDialogs from '@/features/SponsoredListing/components/sponsor-dialogs'
import useProfile from '@/hooks/use-profile'

interface Props {
  listingId: string
  visible: any
  history: History
  closeModal: (id: any) => () => any
  showModal: (id: any) => () => any
}

const IGNORED_QUERY_PARAMETERS = ['sl', 'duration', 'nextStep', 'createListing']

export const ListingSponsorModal = ({
  listingId,
  visible,
  showModal,
  closeModal,
  history
}: Props) => {
  const { search } = history.location

  const onClose = useCallback(() => {
    const newParams = new URLSearchParams(search)

    IGNORED_QUERY_PARAMETERS.forEach(parameter => {
      newParams.has(parameter) && newParams.delete(parameter)
    })

    history.replace({ search: newParams.toString() })
  }, [history, search])

  const queryParams = new URLSearchParams(search)

  const sponsoredInitialValues = queryParams.has('duration')
    ? { duration: queryParams.get('duration') ?? undefined }
    : { duration: undefined }

  const isCreateListing = queryParams.has('createListing')

  const profileData = useProfile()
  const isBillingUserValid = profileData?.billing_user_valid

  useEffect(() => {
    if (queryParams.get('sl') === '1' && !queryParams.has('published')) {
      if (isBillingUserValid) showModal('sponsoredListing')()
      else showModal('billingUser')()
    } else if (queryParams.get('nextSteps') === '1' && !queryParams.has('published')) {
      showModal('nextSteps')()
    }
  }, [queryParams, showModal])

  return (
    <SponsoredListingProvider
      initialValues={sponsoredInitialValues}
      initialStep={0}
      isCreateListing={isCreateListing}
    >
      <SponsorDialogs
        listingId={listingId}
        visible={visible}
        showModal={showModal}
        closeModal={closeModal}
        handleClose={onClose}
      />
    </SponsoredListingProvider>
  )
}
